class AlpineProductBundle extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
    this.addEventListener('change', this.onChange);
    this.querySelector('[data-add-bundle]')?.addEventListener('click', this.addBundle);
    document.querySelector('[data-sticky-add]')?.addEventListener('click', this.addBundle);
    this.setupStickyBar();
    this.updateProductImage('Black');
  }

  onChange = (event) => {
    if (event.target.matches('input[type="radio"]')) {
      this.querySelectorAll('[data-bundle-card]').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(event.target));
      });
      const color = event.target.closest('[data-bundle-card]')?.querySelector('[data-option-position="1"]')?.value;
      if (color) this.updateProductImage(color);
      return;
    }

    if (event.target.matches('[data-option-position="1"]')) {
      this.updateProductImage(event.target.value);
    }
  };

  updateProductImage = (color) => {
    const productMain = document.querySelector('.alpine-product-main');
    const image = productMain?.querySelector('.alpine-product-main__media > img');
    const stickyImage = document.querySelector('.alpine-sticky-buy__product img');
    const key = `image${String(color).replace(/[^a-z0-9]/gi, '')}`;
    const source = productMain?.dataset[key];
    if (image && source) {
      image.src = source;
      image.alt = `${color} Alpine Guards Pro ski shin protectors`;
    }
    if (stickyImage && source) stickyImage.src = source;
  };

  addBundle = async () => {
    const card = this.querySelector('[data-bundle-card].is-selected');
    const button = this.querySelector('[data-add-bundle]');
    const status = this.querySelector('[data-status]');
    if (!card || !button) return;

    const itemsById = new Map();
    for (const row of card.querySelectorAll('.alpine-product-bundle__row')) {
      const values = [...row.querySelectorAll('select')].map((select) => select.value);
      const variant = this.variants.find((item) => item.option1 === values[0] && item.option2 === values[1]);
      if (!variant) {
        status.textContent = `The ${values.join(' / ')} combination is unavailable.`;
        return;
      }
      const existing = itemsById.get(variant.id) || 0;
      itemsById.set(variant.id, existing + 1);
    }

    button.disabled = true;
    button.textContent = 'Adding…';
    status.textContent = '';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          items: [...itemsById].map(([id, quantity]) => ({
            id,
            quantity,
            properties: {'Bundle': `${card.dataset.quantity} pairs`}
          }))
        })
      });
      if (!response.ok) throw new Error('Unable to add this bundle.');
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: {Accept: 'application/json'}
      });
      if (!cartResponse.ok) throw new Error('Your items were added, but the cart could not be opened.');
      document.dispatchEvent(new CustomEvent('alpine:cart:open', {
        detail: {cart: await cartResponse.json()}
      }));
      button.disabled = false;
      button.textContent = 'Added to cart';
      window.setTimeout(() => {
        button.textContent = 'Add to cart';
      }, 1800);
    } catch (error) {
      status.textContent = error.message;
      button.disabled = false;
      button.textContent = 'Add to cart';
    }
  };

  setupStickyBar = () => {
    const sticky = document.querySelector('[data-sticky-buy]');
    const addButton = this.querySelector('[data-add-bundle]');
    if (!sticky || !addButton) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      sticky.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      const passedBuyButton = entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !entry.isIntersecting && passedBuyButton);
    }, {threshold: 0});
    observer.observe(addButton);
  };

}

if (!customElements.get('alpine-product-bundle')) {
  customElements.define('alpine-product-bundle', AlpineProductBundle);
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-choose-yours]');
  if (!link) return;
  const buyBox = document.querySelector('#alpine-buy-box');
  if (!buyBox) return;
  event.preventDefault();
  buyBox.scrollIntoView({behavior: 'smooth', block: 'start'});
});

const sizeGuideDialog = document.querySelector('[data-size-guide-dialog]');

if (sizeGuideDialog) {
  document.querySelectorAll('[data-size-chart-open]').forEach((button) => {
    button.addEventListener('click', () => {
      if (typeof sizeGuideDialog.showModal === 'function') {
        sizeGuideDialog.showModal();
      } else {
        sizeGuideDialog.setAttribute('open', '');
      }
    });
  });

  sizeGuideDialog.querySelector('[data-size-chart-close]')?.addEventListener('click', () => {
    sizeGuideDialog.close();
  });

  sizeGuideDialog.addEventListener('click', (event) => {
    if (event.target === sizeGuideDialog) sizeGuideDialog.close();
  });

  sizeGuideDialog.querySelectorAll('[data-size-unit]').forEach((button) => {
    button.addEventListener('click', () => {
      const unit = button.dataset.sizeUnit;
      sizeGuideDialog.querySelectorAll('[data-size-unit]').forEach((unitButton) => {
        unitButton.setAttribute('aria-pressed', String(unitButton === button));
      });
      sizeGuideDialog.querySelectorAll('[data-size-table]').forEach((table) => {
        table.hidden = table.dataset.sizeTable !== unit;
      });
    });
  });
}
